/**
 * The deployment's build scope (GET /build-scope): Seva Mandir V1 or the full spec. V1 hides what
 * the V1 cuts switched off (paper review, receipt books, advances, bulk file, reconcile counts …).
 * The server defaults to V1, so the console does too while the answer is on its way.
 */
import { useQuery } from '@tanstack/react-query'
import { getOne } from './core'
import { str } from './mappers'

export type BuildScope = 'V1' | 'FULL'

export function parseScope(value: unknown): BuildScope {
  return str(value).toUpperCase() === 'FULL' ? 'FULL' : 'V1'
}

export function useScope(): { scope: BuildScope; v1: boolean } {
  const q = useQuery({
    queryKey: ['console', 'build-scope'],
    queryFn: () => getOne('/build-scope', (r) => parseScope(r.scope)),
    staleTime: Infinity,
    retry: 1,
  })
  const scope = q.data ?? 'V1'
  return { scope, v1: scope === 'V1' }
}
